<template>
  <div class="vue-form__answer">
    <!-- Single selection buttons -->
    <template v-if="question.type === 'single'">
      <answer-button
        v-for="answer in question.answers"
        :key="answer.answer"
        :keyboard="answer.key || null"
        :selected="currentAnswer && answer.answer === currentAnswer.answer"
        @click="selectAnswer(answer)"
        >{{ answer.answer }}
      </answer-button>
    </template>

    <!-- Blocks -->
    <template v-if="question.type === 'block'">
      <!-- draggable="true"
          @drag="makeAbsolute($event)"
          @dragend="finalPosition($event)"
          @drop.prevent
          :style="'background:' + colors[activeColor]"
      -->
      <answer-block
        v-for="answer in question.answers"
        draggable="true"
        :words="answer.answer"
        :key="answer.answer"
        :keyboard="answer.key || null"
        :selected="currentAnswer && answer.answer === currentAnswer.answer"
        @click="selectAnswer(answer)"
      />
    </template>

    <!-- Open single line text -->
    <answer-input
      v-if="question.type === 'text'"
      type="text"
      @input="selectAnswer"
      :value="currentAnswer"
    ></answer-input>
    <answer-input
      v-if="question.type === 'email'"
      type="email"
      @input="selectAnswer"
      :value="currentAnswer"
    ></answer-input>

    <b-button
        v-if="showOKButton"
        @click="handleAnswerInput"
        class="text-center"
        variant="primary"
        >
      Ok
    </b-button>

    <b-button
        v-if="showSubmitButton"
        @click="submit"
        class="text-center"
        variant="primary"
      >
      {{ submitBtnTxt }}
    </b-button>
  </div>
</template>

<script>
import AnswerBlock from "./FormAnswerBlock";
import AnswerButton from "./FormAnswerButton";
import AnswerInput from "./FormAnswerInput";
import FormButton from "./FormButton";

export default {
  props: {
    question: Object,
    submitBtnTxt: String
  },
  components: {
    AnswerBlock,
    AnswerButton,
    AnswerInput,
    FormButton
  },
  computed: {
    showOKButton() {
      if (!this.currentAnswer) return false;

      if (this.question.type === "single") {
        return this.question.answers && this.question.answers.length > 0;
      }

      if (this.question.type === "text" && this.question.minLength) {
        return this.currentAnswer.length >= this.question.minLength;
      }

      if (this.question.type === "email") {
        // eslint-disable-next-line
          return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          this.currentAnswer
        );
      }

      return true;
    },

    showSubmitButton() {
      return this.question.type === "submit";
    }
  },
  methods: {
    handleAnswerInput() {
      this.$emit("answer", {
        question: this.question,
        answer: this.currentAnswer
      });

      this.currentAnswer = null;
    },

    submit() {
      this.$emit("submit");
    },

    selectAnswer(answer) {
      this.currentAnswer = answer;
    },

    enterListener(e) {
      // Enter key === 13
      if (e.which !== 13) return;

      if (this.showOKButton) {
        this.answer();
      }

      if (this.showSubmitButton) {
        this.submit();
      }
    }
  },
  created() {
    window.addEventListener("keyup", this.enterListener);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.enterListener);
  },
  data() {
    return {
      currentAnswer: null // Answer obj
    };
  }
};
</script>

<style lang="scss" scoped>
.vue-form__answer {
  display: flex;
  flex-direction: column;
  align-items: start;

  .action-button {
    margin-top: 2rem;
  }

  margin-bottom: 10px;
}
</style>
